import { Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
export const ResourcesLayout = ({ resources, }) => {
    const navigate = useNavigate();
    const goToResource = React.useCallback((resource) => {
        navigate(`/resource/${resource.id}`);
    }, [navigate]);
    return resources.map((resource) => (React.createElement(Button, { variant: "text", key: resource.id, onClick: () => goToResource(resource), style: { width: "fit-content" }, sx: {
            textTransform: "none",
        } },
        React.createElement(Typography, { variant: "h6" }, resource.name))));
};
